import * as React from "react";
import classnames from "classnames";
/* empty css              */
const _Checkbox = class _Checkbox extends React.PureComponent {
  constructor() {
    super(...arguments);
    this.inputRef = React.createRef();
    this.onClick = (e) => {
      this.props.onChange({
        value: this.props.value,
        checked: e.currentTarget.checked
      });
    };
  }
  render() {
    const { id, checked, disabled, error, ...rest } = this.props;
    return /* @__PURE__ */ React.createElement(
      "label",
      {
        className: classnames("checkbox", [
          this.props.className,
          error && !checked ? "checkbox__error" : ""
        ])
      },
      /* @__PURE__ */ React.createElement(
        "input",
        {
          className: "checkbox__input",
          type: "checkbox",
          id,
          "aria-checked": checked,
          "aria-label": rest["aria-label"],
          "aria-invalid": error && !checked,
          checked: typeof checked === "boolean" ? checked : false,
          disabled,
          onChange: disabled ? void 0 : this.onClick,
          "data-t": this.props["data-t"],
          tabIndex: 0,
          ref: this.inputRef,
          value: "0"
        }
      ),
      /* @__PURE__ */ React.createElement("span", { className: "checkbox__mask" }),
      checked === "mixed" ? /* @__PURE__ */ React.createElement("span", { className: "checkbox__indeterminate" }) : /* @__PURE__ */ React.createElement(
        "svg",
        {
          className: "checkbox__checkmark",
          width: "14",
          height: "13",
          viewBox: "0 0 14 13",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-hidden": true
        },
        /* @__PURE__ */ React.createElement("path", { d: "M1 7.5L4.5 12L13 1", fill: "none" })
      )
    );
  }
  componentDidUpdate(prevProps) {
    if (this.inputRef.current) {
      this.inputRef.current.indeterminate = this.props.checked === "mixed";
    }
  }
};
_Checkbox.defaultProps = {
  checked: false,
  disabled: false
};
let Checkbox = _Checkbox;
export {
  Checkbox as default
};
//# sourceMappingURL=Checkbox.js.map
